import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
import { FJVideoRemoveBgDataConfig } from '../../config/dataConfig/FJVideoRemoveBgDataConfig';

export const VIDEO_REMOVE_BG_USE_CREDIT = 0.4;
export const VIDEO_AUTO_REMOVE_BG_USE_CREDIT = 0.4;

export const MENU_LIST = [
    {
        text: 'auto-remover',
    },
    {
        text: 'customize-remover',
    },
];

export const ID_LIST = {
    REMOVE_BG_CONTROLS: 'remove-bg-controls',
    REMOVE_BG_CUSTOM_GENERATE_BTN: 'remove-bg-custom-generate-btn',
    REMOVE_BG_CANVAS: 'remove-bg-canvas',
};

// 自定义删除背景步骤   0: 选择保留区域  1: 已删除背景、选择替换背景
export const CUSTOM_REMOVE_BG_STEP_LIST = [0, 1];

export const FJSliceVideoBgRemover = createSlice({
    name: 'videoBgRemover',
    initialState: {
        editVideoInfo: null,
        sessionId: null,

        videoBackgroundRemoveFreeNum: 0, // 自定义视频去背景免费次数
        videoAutoBackgroundRemoveFreeNum: 0, // 视频自动去背景免费次数

        totalTime: 0, // 总时长
        currentTime: 0, // 当前时间
        isPlaying: false, // 是否正在播放
        curMenuIndex: 0, // 当前选中的菜单索引

        curSelectBgData: null, // 当前选中的背景图片数据
        curBgColor: '', // 当前选中的背景颜色

        flexClipBgLoadStatus: FJConstant.DEFAULT, // flexClip 背景图片列表加载状态
        backgroundPhotoList: [], // 背景图片列表
        customUploadBgFileList: [], // 自定义上传背景图片列表
        bgUsePhotoLoadingList: [], // 背景图片使用中列表

        customIsUploading: false, // 自定义上传中
        tracklets: [], // 轨迹
        hasPointLoading: false, // 是否正在添加点、删除点
        customRemoverStep: CUSTOM_REMOVE_BG_STEP_LIST[0],
        customRemoverAfterVideoInfo: null, // 自定义删除背景后视频信息
        customRemoverProgress: 10, // 自定义去背景进度
        customRemoverRoughlyAllTime: 0, // 自定义去背景大致总时间
        customRemoverStatus: FJConstant.DEFAULT, // 自定义去背景状态
        customRemoverIsTrimVideo: false, // 是否裁剪视频
        customExportData: {
            formate: FJVideoRemoveBgDataConfig.FORMATE_LIST[0], // 导出格式
            exportStatus: FJConstant.DEFAULT, // 导出状态
            exportProgress: 0, // 导出进度
        }, // 自定义导出数据
        customProgressThumbnailUrl: '', // 自定义去背景进度缩略图url

        autoEditVideoInfo: null, // 自动编辑视频信息
        autoRemoverProgress: 0, // 自动去背景进度
        autoRemoverRoughlyAllTime: 0, // 自动去背景大致总时间
        autoEditVideoIsUploading: false, // 自动去背景视频上传中
        // 自动去背景状态 FJConstant.DEFAULT: 未开始 FJConstant.START: 开始 FJConstant.PROCESSING: 处理中 FJConstant.SUCCESS: 已完成
        autoRemoverStatus: FJConstant.DEFAULT, // 自动去背景状态
        autoRemoverIsTrimVideo: false,
        autoProgressThumbnailUrl: '', // 自动去背景进度缩略图url
        autoExportData: {
            formate: FJVideoRemoveBgDataConfig.FORMATE_LIST[0], // 导出格式
            exportStatus: FJConstant.DEFAULT, // 导出状态
            exportProgress: 0, // 导出进度
        }, // 自动导出数据
    },

    reducers: {
        setSliceEditVideoInfo: (state, action) => {
            state.editVideoInfo = action.payload;
        },
        setSliceSessionId: (state, action) => {
            state.sessionId = action.payload;
        },

        setSliceTotalTime: (state, action) => {
            state.totalTime = action.payload;
        },
        setSliceCurrentTime: (state, action) => {
            state.currentTime = action.payload;
        },
        setSliceTracklets: (state, action) => {
            state.tracklets = action.payload;
            state.hasPointLoading = action.payload.some(tracklet => tracklet.points.some(point => point[2] === 4));
        },
        setSliceIsPlaying: (state, action) => {
            state.isPlaying = action.payload;
        },
        setSliceCurMenuIndex: (state, action) => {
            state.curMenuIndex = action.payload;
        },

        setSliceCustomRemoverStep: (state, action) => {
            state.customRemoverStep = action.payload;
        },

        setSliceCustomRemoverAfterVideoInfo: (state, action) => {
            state.customRemoverAfterVideoInfo = action.payload;
        },

        setSliceFlexClipBgLoadStatus: (state, action) => {
            state.flexClipBgLoadStatus = action.payload;
        },

        setSliceBackgroundPhotoList: (state, action) => {
            state.backgroundPhotoList = action.payload;
        },

        setSliceCurSelectBgData: (state, action) => {
            state.curSelectBgData = action.payload;
        },

        setSliceCurBgColor: (state, action) => {
            state.curBgColor = action.payload;
        },

        setSliceBgUsePhotoLoadingList: (state, action) => {
            state.bgUsePhotoLoadingList = action.payload;
        },

        setSliceCustomUploadBgFileList: (state, action) => {
            state.customUploadBgFileList = action.payload;
        },

        setSliceCustomRemoverStatus: (state, action) => {
            state.customRemoverStatus = action.payload;
        },

        setSliceCustomRemoverProgress: (state, action) => {
            state.customRemoverProgress = action.payload;
        },

        setSliceCustomRemoverRoughlyAllTime: (state, action) => {
            state.customRemoverRoughlyAllTime = action.payload;
        },

        setSliceCustomRemoverIsTrimVideo: (state, action) => {
            state.customRemoverIsTrimVideo = action.payload;
        },

        setSliceCustomExportFormate: (state, action) => {
            state.customExportData = {
                ...state.customExportData,
                formate: action.payload,
            };
        },

        setSliceCustomExportStatus: (state, action) => {
            state.customExportData = {
                ...state.customExportData,
                exportStatus: action.payload,
            };
        },

        setSliceCustomExportProgress: (state, action) => {
            state.customExportData = {
                ...state.customExportData,
                exportProgress: action.payload,
            };
        },

        setSliceAutoExportFormate: (state, action) => {
            state.autoExportData = {
                ...state.autoExportData,
                formate: action.payload,
            };
        },

        setSliceAutoExportStatus: (state, action) => {
            state.autoExportData = {
                ...state.autoExportData,
                exportStatus: action.payload,
            };
        },

        setSliceAutoExportProgress: (state, action) => {
            state.autoExportData = {
                ...state.autoExportData,
                exportProgress: action.payload,
            };
        },

        setSliceCustomIsUploading: (state, action) => {
            state.customIsUploading = action.payload;
        },

        setSliceAutoEditVideoInfo: (state, action) => {
            state.autoEditVideoInfo = action.payload;
        },

        setSliceAutoEditVideoIsUploading: (state, action) => {
            state.autoEditVideoIsUploading = action.payload;
        },

        setSliceAutoRemoverStatus: (state, action) => {
            state.autoRemoverStatus = action.payload;
        },

        setSliceAutoRemoverProgress: (state, action) => {
            state.autoRemoverProgress = action.payload;
        },

        setSliceAutoRemoverRoughlyAllTime: (state, action) => {
            state.autoRemoverRoughlyAllTime = action.payload;
        },

        setSliceVideoBackgroundRemoveFreeNum: (state, action) => {
            state.videoBackgroundRemoveFreeNum = action.payload;
        },

        setSliceVideoAutoBackgroundRemoveFreeNum: (state, action) => {
            state.videoAutoBackgroundRemoveFreeNum = action.payload;
        },

        setSliceCustomProgressThumbnailUrl: (state, action) => {
            state.customProgressThumbnailUrl = action.payload;
        },

        setSliceAutoProgressThumbnailUrl: (state, action) => {
            state.autoProgressThumbnailUrl = action.payload;
        },

        setSliceAutoRemoverIsTrimVideo: (state, action) => {
            state.autoRemoverIsTrimVideo = action.payload;
        },
    },
});

export const {
    setSliceEditVideoInfo,
    setSliceSessionId,
    setSliceTotalTime,
    setSliceCurrentTime,
    setSliceTracklets,
    setSliceIsPlaying,
    setSliceCurMenuIndex,
    setSliceCustomRemoverStep,
    setSliceFlexClipBgLoadStatus,
    setSliceBackgroundPhotoList,
    setSliceCurSelectBgData,
    setSliceCurBgColor,
    setSliceBgUsePhotoLoadingList,
    setSliceCustomUploadBgFileList,
    setSliceCustomRemoverAfterVideoInfo,
    setSliceCustomRemoverStatus,
    setSliceCustomRemoverProgress,
    setSliceCustomRemoverRoughlyAllTime,
    setSliceCustomRemoverIsTrimVideo,
    setSliceCustomExportFormate,
    setSliceCustomExportStatus,
    setSliceCustomExportProgress,
    setSliceCustomIsUploading,
    setSliceAutoEditVideoInfo,
    setSliceAutoEditVideoIsUploading,
    setSliceAutoRemoverStatus,
    setSliceAutoRemoverProgress,
    setSliceAutoRemoverRoughlyAllTime,
    setSliceVideoBackgroundRemoveFreeNum,
    setSliceVideoAutoBackgroundRemoveFreeNum,
    setSliceCustomProgressThumbnailUrl,
    setSliceAutoProgressThumbnailUrl,
    setSliceAutoExportFormate,
    setSliceAutoExportStatus,
    setSliceAutoExportProgress,
    setSliceAutoRemoverIsTrimVideo,
} = FJSliceVideoBgRemover.actions;

export default FJSliceVideoBgRemover.reducer;
